import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat'
dayjs.extend(customParseFormat)
        
import localizedFormat from 'dayjs/plugin/localizedFormat'
dayjs.extend(localizedFormat)
        
import isBetween from 'dayjs/plugin/isBetween'
dayjs.extend(isBetween)
        
import relativeTime from 'dayjs/plugin/relativeTime'
dayjs.extend(relativeTime)
        
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)
        
import timezone from 'dayjs/plugin/timezone'
dayjs.extend(timezone)
        
import duration from 'dayjs/plugin/duration'
dayjs.extend(duration)
        
import calendar from 'dayjs/plugin/calendar'
dayjs.extend(calendar)
        
import updateLocale from 'dayjs/plugin/updateLocale'
dayjs.extend(updateLocale)
        
export default dayjs;